var locationModal = {
    init: function() {
        $('.modal').on('click', '.change-side', function(e) {
            e.preventDefault();
            var that = $(this),
                title = that.data('title');

            if (that.hasClass('pick')) {
                $('.slides').removeClass('right');
            } else {
                $('.slides').addClass('right');
            }

            $('.modal-header').html(title);
        });
    }
};